(function () {
    'use strict';

    function contractorProjectsForEntityController($scope) {
        var vm = this;
        vm.results = [];
        vm.entityId = '';

        $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            vm.entityId = toParams.entityId;
        });
    }

    contractorProjectsForEntityController.$inject = ['$scope'];

    angular.module('ecap.common').controller('contractorProjectsForEntityController', contractorProjectsForEntityController);
})();